import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconRedoComponent } from "./med-icon-redo.component";

@NgModule({
  declarations: [
    MedIconRedoComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconRedoComponent,
  ],
})
export class MedIconRedoModule { }
